export enum ReportTableActionsEnum {
    Download,
    Preview,
    Edit,
    Delete,
    Approve,
    Decline,
    Copy,
    Reset,
    Add,
    Save
}
